import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';

import { queryMap, queryKeys } from '@simple-city/service-graphql-schemas';

import * as actions from '../actions';

import Header from '../components/Header/Header';

const mapStateToProps = ({ auth: { profile } }) => ({ profile });

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const withData = graphql(queryMap[queryKeys.Q_ME])(Header);

const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(withData);

export default HeaderContainer;



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js